module.exports = __webpack_public_path__ + "static/media/method.61e21cef.png";